import { createUseTranslation } from '@shared/hooks/create-use-translation';

import { type TranslationKeys } from './types';

export const useTranslation = createUseTranslation<TranslationKeys>(
  'REGISTRATION_QUESTIONARY'
);
